module.exports = __webpack_public_path__ + "static/img/7.c51a4ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/newbieGuide/img/7.png
// module id = r1HJ
// module chunks = 115